import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/authentication/Login'
import Register from '@/components/authentication/Register'
import Dashboard from '@/components/dashboard/Dashboard'
import TribunalsList from '@/components/tribunals/TribunalsList'

//Project components
import ProjectSearch from '@/components/projects/ProjectSearch'
import ProjectDetail from '@/components/projects/ProjectDetail'

//Freelancer
import FreelancerSearch from '@/components/freelancer/FreelancerSearch'
import FreelancerDetail from '@/components/freelancer/FreelancerDetail'

//Tribunals components
import TribunalDetails from '@/components/tribunals/TribunalDetails'

//User Components
import UserEdit from '@/components/user/UserEdit';


import NProgress from 'nprogress'
import firebase from 'firebase'

//set properly speed
NProgress.configure({ speed: 800 });

Vue.use(Router)

const ifAuthenticated = (to, from, next) => {
  var self = this;
  firebase.auth().onAuthStateChanged(function(user) {
    if (user) {
      // User is signed in.
     next()
     return
    } else {
      // No user is signed in.
      next('/')
    }
  });
}

const ifNotAuthenticated = (to, from, next) => {
  firebase.auth().onAuthStateChanged(function(user) {
    if(!user) {
      next()
      return
    }

    next('/dashboard')
  })
}



const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
      beforeEnter: ifNotAuthenticated,
      meta : {
        title : 'Login | Zoom.tech'
      }
    },
    {
   	  path: '/register',
   	  name: 'Register',
   	  component: Register,
      meta : {
        title : 'Register | Zoom.tech'
      }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      beforeEnter : ifAuthenticated,
      meta : {
        title : 'Dashboard | Zoom.tech'
      }
    },
    {
      path: '/tribunal/list',
      name: 'Tribunals',
      component: TribunalsList,
      beforeEnter: ifAuthenticated,
      meta : {
        title : 'Tribunal list | Zoom.tech'
      }
    },
    {
      path: '/tribunal/:id',
      name: 'tribunalDetails',
      component: TribunalDetails,
      beforeEnter: ifAuthenticated,
      meta : {
        title : 'Tribunal Details | Zoom.tech'
      }
    },
    {
      path : '/project/search',
      name: 'ProjectSearch',
      component: ProjectSearch,
      meta : {
        title : 'Projects | Zoom.tech'
      }
    }, {
      path : '/project/:id',
      name : 'ProjectDetail',
      component: ProjectDetail,
      beforeEnter: ifAuthenticated,
      meta : {
        title : 'Project Details'
      }
    },
    {
      path: '/user/edit/:id',
      name: 'UserEdit',
      component: UserEdit,
      beforeEnter : ifAuthenticated,
      meta : {
        title : 'User edit | Zoom'
      },
    },
    {
      path : '/freelancer/search',
      name: 'FreelancerSearch',
      component: FreelancerSearch,
      meta : {
        title : 'Find a Freelancer | Zoom'
      }
    },
    {
      path : '/freelancer/:id',
      name : 'FreelancerDetail',
      component : FreelancerDetail,
      meta : {
        title : 'Freelancer Detail | Zoom'
      }
    }
  ]
});

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
      // Start the route progress bar.
      NProgress.start()
  }
  next()
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  next();
})

router.afterEach((to, from) => {
  // Complete the animation of the route progress bar.
  NProgress.done()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js